export default __webpack_public_path__ + "static/media/edit-icon.bf9fd4e1.svg";